import { ReactNode, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useWindowSize } from "react-use";
import Collapse from "../../components/bootstrap/Collapse";
import Icon from "../../components/icon/Icon";
import AuthContext from "../../contexts/authContext";
import ThemeContext from "../../contexts/themeContext";
import useDarkMode from "../../hooks/useDarkMode";
import useNavigationItemHandle from "../../hooks/useNavigationItemHandle";
import { authPagesMenu } from "../../menu";
import { NavigationLine } from "../Navigation/Navigation";

const User = () => {
  const { width } = useWindowSize();
  const { setAsideStatus } = useContext(ThemeContext);
  const { userData, setUser } = useContext(AuthContext);

  const navigate = useNavigate();
  const handleItem = useNavigationItemHandle();
  const { darkModeStatus, setDarkModeStatus } = useDarkMode();

  const { t } = useTranslation(["translation", "menu"]);

  return (
    <>
      
      <Collapse isOpen={true} className="user-menu">
        <nav aria-label="aside-bottom-user-menu">
          <div className="navigation">
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() => {
                setDarkModeStatus(!darkModeStatus);
                handleItem();
              }}
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon
                    icon={!darkModeStatus ? "DarkMode" : "LightMode"}
                    color={!darkModeStatus ? "info" : "warning"}
                    className="navigation-icon"
                  />
                  <span className="navigation-text">
                    {!darkModeStatus
                      ? (t("menu:DarkMode") as ReactNode)
                      : (t("menu:LightMode") as ReactNode)}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </nav>
        <NavigationLine />
        <nav aria-label="aside-bottom-user-menu-2">
          <div className="navigation">
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() => {
                if (setUser) {
                  setUser("");
                }
                if (
                  width < Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)
                ) {
                  setAsideStatus(false);
                }
                navigate(`../${authPagesMenu.login.path}`);
              }}
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon icon="Logout" className="navigation-icon" />
                  <span className="navigation-text">
                    {t("menu:Logout") as ReactNode}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </nav>
      </Collapse>
    </>
  );
};

export default User;
